package com.devi3east.bashbuddy

import kotlin.Long
import kotlin.String

public data class FavoriteRecipe(
  public val id: Long,
  public val recipe_id: Long,
  public val added_at: String,
)
